import { render, staticRenderFns } from "./Day06.vue?vue&type=template&id=5310a09d"
import script from "./Day06.vue?vue&type=script&lang=js"
export * from "./Day06.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports